import { State } from 'src/types'
import { listCross } from '../lace/listCross'
import { edgesOfAroundWeb } from './edgeOfAroundWeb'
import { edgesOfNormal } from './edgeOfNormal'

export const edgeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  edgesOfNormal(ctx, state.edge.color)
  edgesOfAroundWeb(ctx, state.edge.color)
  listCross(ctx, state.lace.color)
}
